import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../../../styles/pages-styles/main-dashboard-pages-styles/knowledge-pages-styles/knowledge-exam-styles/KnowledgeExam.css";

const KnowledgeExam = () => {
  const [currentFact, setCurrentFact] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchKnowledgeFact = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(`/user/fetch-knowledge-tutor?page=${currentPage}`);
        setCurrentFact(response.data.knowledgeFacts[0] || null);
        setTotalPages(response.data.totalPages);
      } catch (e) {
        setError(e.message);
        setCurrentFact(null);
        setTotalPages(1);
      } finally {
        setLoading(false);
      }
    };

    fetchKnowledgeFact();
  }, [currentPage]);

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  if (loading) {
    return <div>Loading knowledge fact...</div>;
  }

  if (error) {
    return <div>Error loading knowledge fact: {error}</div>;
  }

  if (!currentFact) {
    return <div>No knowledge facts available.</div>;
  }

  return (
    <div className="KnowledgeExam-Container">
      <div className="header">
        <h1>Knowledge Facts</h1>
      </div>

      <div className="fact-container">
        <div className="fact">
          <div className="scenario">
            <h3>Scenario:</h3>
            <p>{currentFact.fact}</p>
          </div>
        </div>

        <div className="Explanation">
          <h3>Explanation</h3>
          <div className="explanation-content">
            <p>{currentFact.explanation}</p>
          </div>
        </div>
      </div>

      <div className="links-section">
        <h3>Useful Resources</h3>
        <div className="links">
          {currentFact.media && currentFact.media.length > 0 && (
            <div className="video-container">
              <iframe
                width="560"
                height="215"
                src={currentFact.media[0]}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          )}

          {currentFact.link && currentFact.link.length > 0 && (
            <div className="text-links">
              {currentFact.link.map((url, index) => (
                <a
                  key={`text-link-${index}`}
                  href={url}
                  className="text-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="link-text">Link {index + 1}</span>
                </a>
              ))}
            </div>
          )}
        </div>
      </div>

      <footer>
        <button className="prev-btn" onClick={handlePrevious} disabled={currentPage === 1}>
          <span className="btn-icon">←</span> Previous
        </button>

        <button
          className="next-btn"
          onClick={handleNext}
          disabled={currentPage === totalPages}
        >
          Next <span className="btn-icon">→</span>
        </button>
      </footer>
    </div>
  );
};

export default KnowledgeExam;
